<template>
  <div>
    <b-collapse id="collapseOpcoesPesquisa" class="mt-2">
      <b-card class="primary-semi p-2">
        
        <b-row>
          <b-col xs="12" sm="12" md="12" lg="3" xl="3">
            <b-form-group label="Filtros:" label-for="filtrosCombo" class="text-label">
              <multiselect
                v-model="filtro.filtrosCombo"
                :show-labels="false"
                :options="dados.filtrosCombo"
                @remove="filtroRemovido"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                placeholder="Selecione"
                label="text"
                track-by="codFiltro"
              >
                <template slot="selection" slot-scope="{ values, search, isOpen }">
                  <span
                    class="multiselect__single"
                    v-if="values.length &amp;&amp; !isOpen"
                  >{{ values.length }} selecionado(s)</span>
                </template>
              </multiselect>
            </b-form-group>
          </b-col>
        </b-row>
        
        <b-row v-for="filtroSelecionado in filtro.filtrosCombo" :key="filtroSelecionado.numero">
          <b-col v-if="filtroSelecionado.codFiltro == 1" xs="12" sm="12" md="6" lg="3" xl="3">
            <b-form-group label="Nº da Dívida:" label-for="numeroDivida" class="text-label">
              <b-form-input  v-model="filtro.numeroDivida" type="number" id="numeroDivida" maxlength="8" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-for="filtroSelecionado in filtro.filtrosCombo" :key="filtroSelecionado.numero">
          <b-col v-if="filtroSelecionado.codFiltro == 2" xs="12" sm="12" md="6" lg="3" xl="3">
            <b-form-group label="CPF/CNPJ:" label-for="cpfCnpj" class="text-label">
              <the-mask
                v-model="filtro.cpfCnpj"
                id="cpfCnpj"
                class="form-control"
                :mask="['##.###.###/####-##', '###.###.###-##']"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-for="filtroSelecionado in filtro.filtrosCombo" :key="filtroSelecionado.numero">
          <b-col v-if="filtroSelecionado.codFiltro == 3" xs="12" sm="12" md="12" lg="8" xl="8">
            <b-form-group label="Contribuinte:" label-for="contribuinte" class="text-label">
              <b-form-input v-model="filtro.contribuinte" type="text" id="contribuinte" maxlength="100" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-for="filtroSelecionado in filtro.filtrosCombo" :key="filtroSelecionado.numero">
          <b-col v-if="filtroSelecionado.codFiltro == 4" xs="12" sm="12" md="12" lg="3" xl="3">
            <b-form-group label="CADICMS:" label-for="cadicms" class="text-label">
              <b-form-input v-model="filtro.cadimcs" type="text" id="cadicms" maxlength="20" />
            </b-form-group>
          </b-col>
        </b-row>
       <b-row v-for="filtroSelecionado in filtro.filtrosCombo" :key="filtroSelecionado.numero">
          <b-col v-if="filtroSelecionado.codFiltro == 5" xs="12" sm="12" md="12" lg="6" xl="6">
            <b-form-group label="Comarca:" label-for="comarca" class="text-label">
              <multiselect
                v-model="filtro.comarca"
                :show-labels="false"
                :options="dados.comarcas"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                placeholder="Selecione"
                label="nome"
                track-by="codComarca"
              >
                <template slot="selection" slot-scope="{ values, search, isOpen }">
                  <span
                    class="multiselect__single"
                    v-if="values.length &amp;&amp; !isOpen"
                  >{{ values.length }} selecionado(s)</span>
                </template>
              </multiselect>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-for="filtroSelecionado in filtro.filtrosCombo" :key="filtroSelecionado.numero">
          <b-col v-if="filtroSelecionado.codFiltro == 6" xs="12" sm="12" md="12" lg="3" xl="3">
            <b-form-group label="Tipo de Crédito:" label-for="tipoCredito" class="text-label">
              <multiselect
                v-model="filtro.credito"
                :show-labels="false"
                :options="dados.creditos"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                placeholder="Selecione"
                label="nome"
                track-by="id"
              >
                <template slot="selection" slot-scope="{ values, search, isOpen }">
                  <span
                    class="multiselect__single"
                    v-if="values.length &amp;&amp; !isOpen"
                  >{{ values.length }} selecionado(s)</span>
                </template>
              </multiselect>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-for="filtroSelecionado in filtro.filtrosCombo" :key="filtroSelecionado.numero">
          <b-col v-if="filtroSelecionado.codFiltro == 7" xs="12" sm="12" md="12" lg="3" xl="3">
            <b-form-group label="Data de Inscrição (Início):" label-for="dtInscricaoInicio" class="text-label">
              <b-form-input type="date" v-model="filtro.dtInscricaoInicio"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col v-if="filtroSelecionado.codFiltro == 7" xs="12" sm="12" md="12" lg="3" xl="3">
            <b-form-group label="Data de Inscrição (Fim)" label-for="dtInscricaoFim" class="text-label">
              <b-form-input type="date" v-model="filtro.dtInscricaoFim"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-for="filtroSelecionado in filtro.filtrosCombo" :key="filtroSelecionado.numero">
          <b-col v-if="filtroSelecionado.codFiltro == 8" xs="12" sm="12" md="6" lg="3" xl="3">
            <b-form-group label="Erro:" label-for="erro" class="text-label">
              <b-form-input  v-model="filtro.erro" type="text" id="erro" maxlength="100" />
            </b-form-group>
          </b-col>
        </b-row>
        <slot name="maisOpcoes" />
        <hr>
        <b-row>
           <b-col xs="12" sm="12" md="12" lg="12" xl="12">
            <div class="d-flex justify-content-center align-items-center">
              <b-button variant="primary" @click="$emit('filtrar')">
                <i class="fa fa-search"></i> Pesquisar
              </b-button>
              <b-button class="ml-2" variant="secondary" @click="$emit('limparFiltro')">
                <i class="fa fa-eraser"></i> Limpar
              </b-button>
            </div>
           </b-col>
        </b-row>
      </b-card>
    </b-collapse>
  </div>
</template>

<script>
export default {
  props: ["filtro", "dados"],
  methods: {
     filtroRemovido(removedOption, id){
         if(removedOption.codFiltro == 1){
                this.filtro.numeroDivida = null

            }else if(removedOption.codFiltro == 2){
                this.filtro.cpfCnpj = null


            }else if(removedOption.codFiltro == 3){
                this.filtro.contribuinte = null

            }else if(removedOption.codFiltro == 4){
                this.filtro.cadimcs = null

            }else if(removedOption.codFiltro == 5){
                this.filtro.comarca = null

            }else if(removedOption.codFiltro == 6){
                this.filtro.credito = null

            }else if(removedOption.codFiltro == 7){
                this.filtro.dtInscricaoInicio = null
                this.filtro.dtInscricaoFim = null

            }else if(removedOption.codFiltro == 8){
                this.filtro.motivo = null

            }
        }
  }
};
</script>
  
<style>
</style>
